class ProductDescription {
  constructor() {
    this.content = document.querySelector('[data-description-content]');
    this.viewMoreBtn = document.querySelector('[data-view-more-btn]');
    this.viewMoreText = document.querySelector('[data-view-more-text]');
    this.viewLessText = document.querySelector('[data-view-less-text]');
    
    if (!this.content || !this.viewMoreBtn) return;
    
    this.init();
  }

  init() {
    // Store the full height of the content
    this.fullHeight = this.content.scrollHeight;
    // The collapsed height from CSS (3 * 2rem)
    this.collapsedHeight = 6 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    
    // Only show the button if content is taller than collapsed height
    if (this.fullHeight > this.collapsedHeight) {
      this.content.classList.add('is-collapsed');
      this.viewMoreBtn.classList.remove('hidden');
      this.viewMoreBtn.addEventListener('click', this.toggleContent.bind(this));
    }
  }

  toggleContent() {
    const isCollapsed = this.content.classList.contains('is-collapsed');
    
    if (isCollapsed) {
      this.content.style.maxHeight = `${this.fullHeight}px`;
      this.content.classList.remove('is-collapsed');
      this.viewMoreText.classList.add('hidden');
      this.viewLessText.classList.remove('hidden');
    } else {
      this.content.style.maxHeight = `${this.collapsedHeight}px`;
      this.content.classList.add('is-collapsed');
      this.viewMoreText.classList.remove('hidden');
      this.viewLessText.classList.add('hidden');
    }
  }
}

// Initialize the product description functionality
customElements.define('product-description', class extends HTMLElement {
  constructor() {
    super();
    this.productDescription = new ProductDescription();
  }
}); 